import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IAuthInfo } from "../../compiler/global.interface";

export enum ESliceAuth {
    AuthInfo = "AuthInfo"
}

const initialState = {
    avatar:'',
    username: '',
    email:'',
    is_active:0,
    status:0,
    permission:[],
    access_token: '',
    refresh_token: '',
    company_uuid:'',
    firstname:'',
    lastname:'',
} as IAuthInfo;

const authSlice = createSlice({
    name: ESliceAuth.AuthInfo,
    initialState,
    reducers: {
        setAuthInfo: (state, action: PayloadAction<Partial<IAuthInfo>>) => {
            state = { ...state, ...action.payload}
            return state;
        },
        setAccessToken: (state, action) => {
            state.refresh_token = action.payload.refresh_token;
            state.access_token = action.payload.access_token;
            return state;
        },
        clearAuthInfo: (state) => {
            state = initialState;
            return state;
        }
    }
});

export const { clearAuthInfo, setAuthInfo, setAccessToken } = authSlice.actions;
export default authSlice.reducer;
